import { useEffect, useRef } from 'react';
import { useRouter } from 'next/router';
import { getLanguageFromLocale, localeToUpperCase } from '../../../utils';
import { trustpilotBusinessUnitIds, trustpilotTemplateIds } from '../utils/trustpilot.config';
import { RatingsAndReviews } from './Reviews.styles';

export function Reviews({
  productId,
  productName,
  numberOfReviews,
}: {
  productId: string;
  productName: string;
  numberOfReviews: number;
}) {
  const { locale } = useRouter();
  const templateId = trustpilotTemplateIds.productReviewsMultiSource;
  const { buid } = trustpilotBusinessUnitIds;
  const widgetRef = useRef(null);
  const widgetHeight = numberOfReviews > 1 ? '700px' : '350px';

  useEffect(() => {
    if (window.Trustpilot) {
      window.Trustpilot.loadFromElement(widgetRef.current, true);
    }
  }, [productId]);

  return (
    <RatingsAndReviews>
      <div
        ref={widgetRef}
        className="trustpilot-widget"
        data-locale={localeToUpperCase(locale as string)}
        data-template-id={templateId}
        data-businessunit-id={buid}
        data-style-height={widgetHeight}
        data-style-width="100%"
        data-sku={productId}
        data-name={productName}
        data-no-reviews="collapse"
        data-fullwidth="true"
        data-review-languages={getLanguageFromLocale(locale as string)}
      />
    </RatingsAndReviews>
  );
}

export default Reviews;
